import { Modal } from "antd";
import React from "react";
import { useDispatch, useSelector } from "react-redux";

import "../../../../assets/style/modalStyle/delete.scss";
import { pupSelector } from "../../../../services/selector/index.";
import { setOpenPUDelete } from "../../../../services/slice/PopUpSlice";
import TranslateText from "../../TranslateText";
import BaseButton from "../../Button/BaseButton";

const ModalDelete = ({
  setIsDelete,
  width = 580,
  handleDelete,
  title = "Xóa bài viết",
  textDisable,
  content,
}) => {
  const statePup = useSelector(pupSelector);
  const { dataDelete } = statePup;
  const dispatch = useDispatch();
  const handleCancel = () => {
    dispatch(setOpenPUDelete({ stateOpen: false, content: "", id: "" }));
    setIsDelete(false);
  };

  return (
    <>
      <Modal
        maskClosable={false}
        title={
          <span style={{ fontSize: 20 }}>
            <TranslateText text={title} />
          </span>
        }
        centered
        open={dataDelete.isOpenPUDelete}
        className="warrperModalDelete"
        footer={[
          <div className="evenSpace ">
            <BaseButton
              content={"Hủy bỏ"}
              typeBtn="mainBtn btnCancel"
              width={155}
              handleClick={handleCancel}
            />

            <BaseButton
              width={155}
              content={"Đồng ý"}
              typeBtn="btnOrange"
              handleClick={handleDelete}
            />
          </div>,
        ]}
        width={width}
        onCancel={handleCancel}
      >
        {!content ? (
          <p style={{ fontSize: 20, textAlign: "center" }}>
            <TranslateText text={textDisable} />{" "}
            <span style={{ color: "#047DE7" }}>
              {dataDelete.contentPUDelete}
            </span>{" "}
            <TranslateText text={"không?"} />
          </p>
        ) : (
          <p style={{ fontSize: 20, textAlign: "center" }}>
            <TranslateText text={content} />
          </p>
        )}
      </Modal>
    </>
  );
};

export default ModalDelete;
